// import { Celebrity } from "components/Celebrity";
import styles from "./CarouselSlider.module.scss";
import classNames from "classnames/bind";
import { FeaturedImage } from "../FeaturedImage/index";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar, Autoplay } from "swiper";
import "swiper/css/bundle";
let cx = classNames.bind(styles);
interface CelebSliderProps {
  carouselTitle?: string;
  guests: any[];
}

const CarouselSlider = ({ carouselTitle, guests }: CelebSliderProps) => {
  const swiperSettings = {
    slidesPerView: 1,
    spaceBetween: 10,
    slidesPerGroup: 1,
    scrollbar: {
      hide: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    },
  };

  const rowCount = guests?.length;

  return (
    <section className={`${styles[`celeb-carousel`]} my-lg`}>
      <h2 className={`${styles[`carousel-header`]}`}>{carouselTitle}</h2>

      {guests && rowCount >= 4 ? (
        <Swiper
          {...swiperSettings}
          modules={[Scrollbar, Autoplay, Navigation]}
          className={`mySwiper`}
          scrollbar={{ draggable: true }}
          navigation={true}
        >
          {guests.map((celeb: any) => {
            const {
              id,
              title,
              uri,
              guestProps: {
                carouselCaption,
                carouselImage,
                guestDays,
                headshot,
              },
            } = celeb;

            const formattedMonth = new Date(
              guestDays[0]?.guestDate
            ).toLocaleDateString("en-US", {
              month: "long",
            });

            return (
              <SwiperSlide key={id}>
                <a className={`${cx(`celeb-card-link`)}`} href={uri} key={id}>
                  <div className={`${cx(`celeb-card`)}`}>
                    {carouselImage || headshot ? (
                      <FeaturedImage
                        className={`${cx(`celeb-card-img`)}`}
                        image={carouselImage ? carouselImage : headshot}
                        key={id}
                      />
                    ) : null}
                    <div className={`${cx(`celeb-card-info`)} p-xs`}>
                      <div className={`${cx(`inner-card-info`)}`}>
                        <h3 className={`${cx(`guest-name`)}`}>{title}</h3>
                        {guestDays ? (
                          <div className={`${cx(`event-dates`)}`}>
                            <p className={`${cx(`event-month`)} color-red`}>
                              {formattedMonth}
                            </p>
                            {guestDays?.map((dates: any, index: number) => {
                              const sDays = [
                                "Sun",
                                "Mon",
                                "Tues",
                                "Wed",
                                "Thur",
                                "Fri",
                                "Sat",
                              ];
                              const d = new Date(dates.guestDate);
                              const numberedDays = new Date(
                                dates.guestDate
                              ).toLocaleDateString("en-US", {
                                day: "numeric",
                              });
                              return (
                                <div
                                  className={`${cx(`guest-days`)}`}
                                  key={`${dates}-${index}`}
                                >
                                  <p className={`${cx(`guest-day`)}`}>
                                    {sDays[d.getDay()]}
                                  </p>
                                  <p
                                    className={`${cx(
                                      `guest-day-num`
                                    )} color-red`}
                                  >
                                    {numberedDays}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        ) : null}
                        <p className={`${cx(`guest-caption`)} color-primary`}>
                          {carouselCaption}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <div className={`${cx(`guests-overflow-container`)}`}>
          {guests.map((celeb: any) => {
            const {
              id,
              title,
              uri,
              guestProps: {
                carouselCaption,
                carouselImage,
                guestDays,
                headshot,
              },
            } = celeb;

            const formattedMonth = new Date(
              guestDays[0]?.guestDate
            ).toLocaleDateString("en-US", {
              month: "long",
            });

            return (
              <div className={`${cx(`guests-overflow-cards`)}`} key={id}>
                <a className={`${cx(`celeb-card-link`)}`} href={uri} key={id}>
                  <div className={`${cx(`celeb-card`)}`}>
                    {carouselImage || headshot ? (
                      <FeaturedImage
                        className={`${cx(`celeb-card-img`)}`}
                        image={carouselImage ? carouselImage : headshot}
                        key={id}
                      />
                    ) : null}
                    <div className={`${cx(`celeb-card-info`)} p-xs`}>
                      <div className={`${cx(`inner-card-info`)}`}>
                        <h3 className={`${cx(`guest-name`)}`}>{title}</h3>
                        {guestDays ? (
                          <div className={`${cx(`event-dates`)}`}>
                            <p className={`${cx(`event-month`)} color-red`}>
                              {formattedMonth}
                            </p>
                            {guestDays?.map((dates: any, index: number) => {
                              const sDays = [
                                "Sun",
                                "Mon",
                                "Tues",
                                "Wed",
                                "Thur",
                                "Fri",
                                "Sat",
                              ];
                              const d = new Date(dates.guestDate);
                              const numberedDays = new Date(
                                dates.guestDate
                              ).toLocaleDateString("en-US", {
                                day: "numeric",
                              });
                              return (
                                <div
                                  className={`${cx(`guest-days`)}`}
                                  key={`${dates}-${index}`}
                                >
                                  <p className={`${cx(`guest-day`)}`}>
                                    {sDays[d.getDay()]}
                                  </p>
                                  <p
                                    className={`${cx(
                                      `guest-day-num`
                                    )} color-red`}
                                  >
                                    {numberedDays}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        ) : null}
                        <p className={`${cx(`guest-caption`)} color-primary`}>
                          {carouselCaption}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default CarouselSlider;
